import React, { useCallback, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { NumPad, useClickOutside } from '@pascal/pascal-core';
import { checkMaxAutoCashOutValue, setDefaultValueNumpad } from '../../../../helpers/util';
import { minOddConstant } from '../../../../enums/gameConstants';
import { betDataStore, gameStore } from '../../../../store';
import { GameResponseTypeName, numPadTypes } from '../../../../enums';

export const NumpadWrapper = observer(
  ({
    namPudInputValue,
    sectionName,
    activeGameType,
    limits,
    updateNumPudInputValue,
    isOpenNumpad,
    t,
  }) => {
    const { betAmount: betAmountVal, autoCashOutOdd } =
      betDataStore.betsSectionsData[activeGameType];
    const [ref, hasClickedOutside] = useClickOutside();

    useEffect(() => {
      if (hasClickedOutside) {
        gameStore.setNumPadData({
          isOpen: false,
          currentInputValue: null,
        });
      }
    }, [hasClickedOutside]);

    const checkMaxOdd = useCallback(
      (value) => {
        const maxAutoCashOutValue = checkMaxAutoCashOutValue(value, limits.maxWin);
        if (
          maxAutoCashOutValue &&
          autoCashOutOdd > maxAutoCashOutValue &&
          betAmountVal <= limits.maxBet
        ) {
          const maxValue =
            maxAutoCashOutValue > minOddConstant ? maxAutoCashOutValue : minOddConstant;
          betDataStore.setAutoCashOutOdd(maxValue, activeGameType);
        }
      },
      [autoCashOutOdd, betAmountVal]
    );

    const handleSubmitNumPad = (isConfirmed) => {
      const { betAmount, autoCashOutOdd } = numPadTypes;
      const setNumPudValueBySectionName = {
        [betAmount]: () => {
          checkMaxOdd(namPudInputValue);
          return setDefaultValueNumpad(
            namPudInputValue,
            betDataStore.setBetAmount,
            { minValue: limits.minBet, maxValue: limits.maxBet },
            GameResponseTypeName.Bet
          );
        },
        [autoCashOutOdd]: () => {
          return setDefaultValueNumpad(
            namPudInputValue,
            betDataStore.setAutoCashOutOdd,
            {
              minValue: minOddConstant,
              maxValue: checkMaxAutoCashOutValue(betAmountVal, limits.maxWin, minOddConstant),
            },
            GameResponseTypeName.AutoCashOut
          );
        },
      };

      if (isConfirmed) {
        setNumPudValueBySectionName?.[sectionName]();
        gameStore.setNumPadData({
          isOpen: false,
          currentInputValue: null,
        });
      }
    };

    return (
      <div ref={ref} className='numpad-wr-for-outside-click'>
        <NumPad
          t={t}
          isOpen={isOpenNumpad}
          limits={limits}
          onSubmit={handleSubmitNumPad}
          amountValue={namPudInputValue}
          setAmountValue={updateNumPudInputValue}
        />
      </div>
    );
  }
);
